import { createUseStyles } from 'react-jss';
import { getLengthValue } from '../../system';
export const useFlexClasses = createUseStyles({
    flex({ theme, ...props }) {
        const rules = {};
        if (props.gap) {
            rules.gap = getLengthValue({ length: props.gap, theme });
        }
        if (props.alignItems) {
            rules.alignItems = props.alignItems;
        }
        if (props.flexDirection) {
            rules.flexDirection = props.flexDirection;
        }
        if (props.flexWrap) {
            rules.flexWrap = props.flexWrap;
        }
        if (props.alignContent) {
            rules.alignContent = props.alignContent;
        }
        if (props.justifyContent) {
            rules.justifyContent = props.justifyContent;
        }
        if (props.flexFlow) {
            rules.flexFlow = props.flexFlow;
        }
        return rules;
    },
});
